/* jshint esversion: 6 */
import React from 'react';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';

let isConnecting = false;

let SocialListModule = {

    // Opens the link page's settings screen, which links on to the page itself. The
    // client app has no route for that screen, so it still opens the page directly.
    linkpage: function (e) {
        var id = e.currentTarget.dataset.id;

        if (this.props.appName === 'dlvr') {
            this.props.router.navigate('/config/socials/detail/' + id + '/linkpage');
            return;
        }
        window.open('/linkpage/' + id, '_blank');
    },

    // Whether this service has a link page at all. LINKPAGE_SERVICES comes from
    // Linkpage::services(), so this tracks what dlvrit.me actually serves.
    hasLinkpage: function (psID, constants) {
        var services = constants.LINKPAGE_SERVICES || [];

        return services.indexOf(parseInt(psID, 10)) !== -1;
    },

    reauthorizeSocial: function(e) {
        var serviceId = e.currentTarget.dataset.serviceid,
            paId = e.currentTarget.dataset.id,
            url = "/remote/beginreauth?psID=:psId&paID=:paId&state=:state&final=:final",
            date = new Date(),
            state = ['REAUTH', serviceId, paId, date.getTime()].join("_"),
            constants = this.props.app.config.constants;

        if (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
            if (parseInt(serviceId) === constants.POST_SVC_TWITTER) {
                this.props.closeAllModals();
                if (this.props.showTwitterWarning) {
                    this.props.showTwitterWarning();
                }
                return;
            }
        }

        if (parseInt(serviceId) === constants.POST_SVC_BLUESKY) {
            let social = this.props.socials.list.find(({id}) => { return id === parseInt(paId); });
            if (social) {
                this.props.closeAllModals();
                let blueskyModal = (
                    <SocialModal
                        {...this.props}
                        paId={paId}
                        handle={social.name}
                        activeTab="blueskycreds"
                        context="reconnect"
                    />
                );
                this.props.addModal(blueskyModal);
            }
            return;
        }

        if (isConnecting) {
            return;
        }

        isConnecting = true;

        e.preventDefault();
        e.stopPropagation();

        url = url.replace(':psId', serviceId);
        url = url.replace(':paId', paId);
        url = url.replace(':state', state);
        let finalUrl = this.props.cleanUrl(window.location.href);
        url = url.replace(':final', window.encodeURIComponent(finalUrl));
        window.location.assign(url);
    },

    reauthorizeSocialClick: function(e) {

        e.preventDefault();
        e.stopPropagation();

        SocialListModule.reauthorizeSocial.apply(this, [e]);

    }

};

export default SocialListModule;
